import { render, staticRenderFns } from "./mail.vue?vue&type=template&id=a64ac3dc&scoped=true"
import script from "./mail.vue?vue&type=script&lang=js"
export * from "./mail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64ac3dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a64ac3dc')) {
      api.createRecord('a64ac3dc', component.options)
    } else {
      api.reload('a64ac3dc', component.options)
    }
    module.hot.accept("./mail.vue?vue&type=template&id=a64ac3dc&scoped=true", function () {
      api.rerender('a64ac3dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/chat/send-boxes/mail.vue"
export default component.exports